import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { NamedEntity } from "../models/named-entity.model";
import { TreeViewEntity } from "../models/tree-view-entity.model";
import {
  AssignmentBusinessUnitInfo,
  BusinessUnit,
  AssignBusinessUnitAdministrator,
} from "../models/identity";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable()
export class BusinessUnitService {
  public businessUnitAssignments: Array<AssignmentBusinessUnitInfo> = [];
  private readonly apiController = "api/BusinessUnit";

  constructor(private readonly httpService: HttpClient) {}

  getTreeView(): Observable<Array<TreeViewEntity>> {
    return this.httpService.get(`${this.apiController}/treeview`) as Observable<
      Array<TreeViewEntity>
    >;
  }

  public getAll(): Observable<Array<NamedEntity>> {
    return this.httpService.get(`${this.apiController}`) as Observable<
      Array<NamedEntity>
    >;
  }

  public getAllBusinessUnitInfo() {
    return this.httpService.get(
      `${this.apiController}/getbusinessunitsInfo`
    ) as Observable<Array<AssignmentBusinessUnitInfo>>;
  }

  public getEmployeeBusinessUnits(): Observable<Array<BusinessUnit>> {
    return this.httpService.get(
      `${this.apiController}/employeeBusinessUnits`
    ) as Observable<Array<BusinessUnit>>;
  }

  public getBusinessUnit(id: number): Observable<BusinessUnit> {
    return this.httpService.get<BusinessUnit>(`${this.apiController}/${id}`);
  }

  public getBusinessUnitInfo(pattern: string) {
    return this.httpService.get(
      `${this.apiController}/getbusinessunitInfo/search/${pattern}`
    ) as Observable<Array<BusinessUnit>>;
  }

  public getCountry(pattern: string) {
    return this.httpService.get(
      `${this.apiController}/country/search/${pattern}`
    ) as Observable<Array<AssignmentBusinessUnitInfo>>;
  }

  public getAssignedToBusinessUnitBusinessUnitAdministrators(
    businessUnitId: number
  ) {
    return this.httpService.get(
      `${this.apiController}/businessunitadministrator/assignedtobusinessunit/${businessUnitId}`
    ) as Observable<Array<AssignBusinessUnitAdministrator>>;
  }

  public updateBussinesUnitAdministrators(
    businessUnitId: number,
    anotherBusinessUnitIds: Array<number>,
    assignBusinessUnitAdministrators: Array<AssignBusinessUnitAdministrator>
  ) {
    return this.httpService
      .post(
        `${this.apiController}/businessunitadministrator/updateassignment`,
        this.mapAssignmentData(
          businessUnitId,
          anotherBusinessUnitIds,
          assignBusinessUnitAdministrators
        )
      )
      .pipe(distinctUntilChanged()) as Observable<number>;
  }

  private mapAssignmentData(
    businessUnitId: number,
    anotherBusinessUnitIds: Array<number>,
    assignBusinessUnitAdministrators: Array<AssignBusinessUnitAdministrator>
  ) {
    const businessUnitAdministratorIds = assignBusinessUnitAdministrators.map(
      (x) => x.id
    );
    return {
      businessUnitId: businessUnitId,
      anotherBusinessUnitIds: anotherBusinessUnitIds,
      businessUnitAdministratorIds: businessUnitAdministratorIds
    };
  }
}
